import React, { useRef } from 'react';
import '../App.css';

// Imágenes
import uniforme from '../img/uniformenz.jpg';
import Aviso1 from '../img/Lista de Espera.jpg';
import Aviso2 from '../img/Inicio-Clases-2026.png';
import Aviso4 from '../img/Agosto - CEM Compañerismo_001.jpg';
import Aviso5 from '../img/Recomendaciones para consumo de carnes, pescado y huevo.jpg';
import Aviso10 from '../img/Respeto.jpg';
import Aviso11 from '../img/Desayuno.jpg';
import Aviso12 from '../img/Proceso de Matricula Estudiantes Nuevos_001.jpg';

// Ícono PDF
import PdfIcon from '../img/pdf-icon.png';

const EventsComponent = () => {
  const scrollRef = useRef(null);

  const eventsData = [

    /* {
      id: 2,
      date: 'Regreso a Clases 2026',
      title: 'Miercoles 04 de Marzo',
      description: '',
      imageUrl: Aviso2,
      type: 'auto',
    },*/

    {
      id: 1,
      date: '¡Atención Apoderados/as!',
      title: 'Anótate en la lista de Espera de Nuestro Colegio',
      description: '',
      imageUrl: Aviso1,
      type: 'auto',
      link: 'https://registropublicodigital.mineduc.gob.cl/rpd-app-registro-apoderado/login',
    },


    {
      id: 12,
      date: 'Proceso de Matrícula Estudiantes Nuevos 2026',
      title: '',
      description: '',
      imageUrl: Aviso12,
      type: 'auto',
    },
    
    {
      id: 0,
      date: 'Uniforme Escolar',
      title: 'Escuela Nueva Zelandia 2025',
      description: '',
      imageUrl: uniforme,
      type: 'auto',
    },
  ];

  // Abrir archivo
  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  // Scroll carrusel
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  // Render dinámico imagen / video / PDF / LINK
  const renderMedia = (event) => {
    const { imageUrl, link } = event;
    const ext = imageUrl.split('.').pop().toLowerCase();

    const handleDoubleClick = () => {
      if (link) {
        window.open(link, '_blank');
      } else {
        openFileInNewTab(imageUrl);
      }
    };

    // 🎥 VIDEO
    if (['mp4', 'mov', 'webm'].includes(ext)) {
      return (
        <video
          src={imageUrl}
          autoPlay
          loop
          muted
          playsInline
          onDoubleClick={handleDoubleClick}
          className="event-video"
        />
      );
    }

    // 🟥 PDF
    if (ext === 'pdf') {
      return (
        <img
          src={PdfIcon}
          alt="PDF"
          className="pdf-thumbnail"
          onDoubleClick={handleDoubleClick}
        />
      );
    }

    // 🖼️ Imagen
    return (
      <img
        src={imageUrl}
        alt="Aviso"
        className="event-media"
        onDoubleClick={handleDoubleClick}
        style={{ cursor: link ? 'pointer' : 'default' }}
      />
    );
  };

  return (
    <div id="events-component" className="events-component">
      <h2>Informaciones (Doble click para abrir)</h2>

      <div className="carousel-container">
        <button className="arrow left" onClick={scrollLeft}>
          &#10094;
        </button>

        <div className="event-cards-container" ref={scrollRef}>
          {eventsData.map((event) => (
            <div key={event.id} className="event-card">
              <div className="event-date">{event.date}</div>

              <div className="event-details">
                <h3>{event.title}</h3>
                <p>{event.description}</p>

                {renderMedia(event)}
              </div>
            </div>
          ))}
        </div>

        <button className="arrow right" onClick={scrollRight}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default EventsComponent;
